import React, { useState } from 'react'
import Header_Bus from './Header_Bus'
import useWindowDimensions from "../../../hook/useWindowDimensions";

const sidebarClass = {
  intial: {
    main: "app-container app-theme-white_bus body-tabs-shadow fixed-sidebar fixed-header",
    button: "hamburger close-sidebar-btn hamburger--elastic"
  }
}

const sidebarClassMobile = {
  intial: {
    main: "app-container app-theme-white_bus body-tabs-shadow fixed-sidebar fixed-header closed-sidebar-mobile closed-sidebar",
    button: "hamburger hamburger--elastic mobile-toggle-nav"
  }
}

export default function LayoutMain_Bus(props) {
  const [mainClass, setMainClass] = useState(sidebarClass);
  const [mainClassMobile, setMainClassMobile] = useState(sidebarClassMobile);
  const { width } = useWindowDimensions();

  let class_name;
  const buttonClicked = () => {
    if (mainClass.intial.main.indexOf("closed-sidebar") === -1) {
      setMainClass((preObj) => { return { intial: { main: preObj.intial.main + " closed-sidebar", button: preObj.intial.button + " is-active" } } })

    } else {
      setMainClass((preObj) => { return sidebarClass })
    }
  }

  const buttonClickedMobile = () => {
    if (mainClassMobile.intial.main.indexOf("sidebar-mobile-open") === -1) {
      setMainClassMobile((preObj) => { return { intial: { main: preObj.intial.main + " sidebar-mobile-open", button: preObj.intial.button + " is-active" } } })

    } else {
      setMainClassMobile((preObj) => { return sidebarClassMobile })
    }
  }
  if (width >= 991) {
    class_name = mainClass.intial.main;
  } else {
    class_name = mainClassMobile.intial.main;
  }
  return (
    <>
      <div className={class_name}>
        <Header_Bus />
        <div className="container-fluid pt-2 pb-2" style={{ background: '#F2F3FC' }}>
          <div className="app-main_bus">
            <div className="app-main__inner">
              {props.children}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
